import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLID,
  GraphQLBoolean
} from 'graphql'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import { Context } from '../shared'

export interface ToggleSensitiveDataPolicyMutationArgs {
  readonly input: {
    readonly organizationID: string
    readonly policyID: string
    readonly enabled: boolean
  }
}

const toggleSensitiveDataPolicyArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'ToggleSensitiveDataPolicyMutationArg',
      description: 'Mutation input type for updating sensitive data policy.',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization that owns the policy being mutated.',
          type: new GraphQLNonNull(GraphQLID)
        },
        policyID: {
          description: 'The ID of the policy to be updated',
          type: new GraphQLNonNull(GraphQLID)
        },
        enabled: {
          description:
            'Flag indicating if this policy should be enabled or disabled',
          type: new GraphQLNonNull(GraphQLBoolean)
        }
      })
    })
  }
}

export const toggleSensitiveDataPolicy: GraphQLFieldConfig<
  any,
  Context,
  ToggleSensitiveDataPolicyMutationArgs
> = {
  description: 'Toggle sensitive data policy',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: toggleSensitiveDataPolicyArgs,
  resolve: async (_source, args, context): Promise<GenericMutationResponse> => {
    if (!args.input) {
      throw new Error('mutation input parameter is required')
    }

    const { organizationID, policyID, enabled } = args.input

    await context.connector.put(
      `${organizationID}/sensitivedata/policy/${policyID}/enabled`,
      {
        enabled
      }
    )

    return {
      _placeholder: true
    }
  }
}
